var map = {
	"./photo1.jpg": 6247,
	"./photo10.jpg": 1186,
	"./photo11.jpg": 2771,
	"./photo12.jpg": 6154,
	"./photo13.jpg": 38,
	"./photo14.jpg": 3496,
	"./photo15.jpg": 8379,
	"./photo16.jpg": 6849,
	"./photo17.jpg": 6713,
	"./photo18.jpg": 6655,
	"./photo19.jpg": 5006,
	"./photo2.jpg": 8813,
	"./photo20.jpg": 5146,
	"./photo21.jpg": 2894,
	"./photo22.jpg": 5399,
	"./photo23.jpg": 3735,
	"./photo24.jpg": 6455,
	"./photo25.jpg": 1618,
	"./photo26.jpg": 1853,
	"./photo27.jpg": 8257,
	"./photo3.jpg": 9059,
	"./photo4.jpg": 3495,
	"./photo5.jpg": 1774,
	"./photo6.jpg": 5884,
	"./photo7.jpg": 4259,
	"./photo8.jpg": 3435,
	"./photo9.jpg": 6269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5763;